import errors from '@shared/config/errors';
import router from '@app/config/router';
import store from '@app/config/store';
import i18n from '@app/config/i18n';

export default errors({
  router, store, i18n, loginRoute: { name: 'login' },
});
